import { createIcon } from '../CreateIcon';

export const IconLargeScreen = createIcon({
  viewBox: '0 0 24 24',
  paths: (
    <>
      <path
        d="M23.0901 2.67773H0.804408C0.330301 2.67773 -0.0527344 3.06077 -0.0527344 3.53488V20.6777C-0.0527344 21.1518 0.330301 21.5349 0.804408 21.5349H23.0901C23.5642 21.5349 23.9473 21.1518 23.9473 20.6777V3.53488C23.9473 3.06077 23.5642 2.67773 23.0901 2.67773ZM22.0187 19.6063H1.87584V4.60631H22.0187V19.6063ZM4.36959 17.4018C4.45262 17.4849 4.58923 17.4849 4.67227 17.4018L9.2928 12.7813L12.3571 15.8483C12.4401 15.9313 12.5767 15.9313 12.6598 15.8483L20.6151 7.88756C20.6982 7.80452 20.6982 7.66791 20.6151 7.58488L19.6294 6.59916C19.5891 6.55928 19.5347 6.53691 19.4781 6.53691C19.4214 6.53691 19.367 6.55928 19.3267 6.59916L12.5098 13.4188L9.44548 10.3518C9.40521 10.312 9.35082 10.2896 9.29414 10.2896C9.23746 10.2896 9.18308 10.312 9.1428 10.3518L3.38655 16.1108C3.34667 16.151 3.3243 16.2054 3.3243 16.2621C3.3243 16.3188 3.34667 16.3732 3.38655 16.4135L4.36959 17.4018Z"
        fill="black"
        fillOpacity="0.45"
      />
    </>
  ),
});
